import { useAuth } from '../contexts/AuthContext'
import Layout from './Layout'
import MarketingHeader from './MarketingHeader'

const HelpLayout = ({ children }) => {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    )
  }

  if (user) {
    return <Layout>{children}</Layout>
  }

  return (
    <div className="marketing-layout">
      <MarketingHeader />
      <div className="marketing-layout__content">
        {children}
      </div>
    </div>
  )
}

export default HelpLayout
